/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { ledgersRetrieveApiV1LedgersLedgerCanisterIdGet } from "../../funcs/ledgersRetrieveApiV1LedgersLedgerCanisterIdGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations.RetrieveApiV1LedgersLedgerCanisterIdGetRequest$inboundSchema,
};

export const tool$ledgersRetrieveApiV1LedgersLedgerCanisterIdGet:
  ToolDefinition<typeof args> = {
    name: "ledgers-retrieve-api-v1-ledgers-ledger-canister-id-get",
    description: `Get ledger

### How is the data for this endpoint gathered?

Ledgers belonging to an SNS are automatically detected by looking at the SNS-WASM canister.
Ledgers such as the ckBTC are currently added manually.`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await ledgersRetrieveApiV1LedgersLedgerCanisterIdGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
